import { useAuth0 } from "@auth0/auth0-react";
import FinanceService from "Lib/API/Finance";
import Action from "components/ActionPopOver";
import AlertDialog from "components/Dialog";
import MainDialog from "components/Dialog/MainDialog";
import MyModal from "components/MyModal";
import { formatDate, numberFormat } from "helper";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { PayNow } from "store/redux/actions/index";
import { DateFormetContext } from "../../../app/App.js";
import { SetRecurringChecks } from "../../../app/redux/actions/index";
import NewCharge from "../../../pages/NewFinance/NewCharge";
import UserContext from "../../../pages/NewFinance/NewChargeContext";
import { HidePaymentInfoButton, dispacthPayNowRow } from "../../../store/redux/actions/index";
import "../../../theme/poppins.css";
import { CheckFloatValue } from "../../../utils/functions";
import InvoiceDocument from "../Documents/InvoiceDocument";
import ReceiptDocument from "../Documents/ReceiptDocument";

export const Payment = ({ data, onReversalClick, batchTable, downloadFileClickHandler, viewFileClickHandler, sharedFileClickHandler,
  hideReceiptButtons,
  hideInvoiceButtons,
  switchType,
  hideActions,
  hideDelete = false,
  hidePayNow = false,
  disableActionButton = false,
}) => {
  // let hitoryDetails = data?.charge?.payment?.History?.map(
  //   (item) => item.paymnetMethod?.method ?? ""
  // );
  // hitoryDetails = [...new Set(hitoryDetails)];
  const dateFormet = React.useContext(DateFormetContext);
  const { getAccessTokenSilently } = useAuth0();
  const [reversalActionTypes, setReversalActionTypes] = useState(false);
  const [getTypes, setActionTypes] = useState([]);
  const [paymentId, setPaymentId] = useState();
  const [chargeId, setchargeId] = useState();
  const [shareIncvoicePDF, setShareInvoicePDF] = useState("");
  const [shareReceiptPDF, setShareReceiptPDF] = useState("");
  const [invoiceFile, setInvoiceFile] = useState(false);
  const [receiptFile, setReceiptFile] = useState(false);
  const [invoiceDownload, setInvoiceDownload] = useState(false);
  const [receiptDownload, setReceiptDownload] = useState(false);
  const [invoiceReceiptData, setInvoiceReceiptData] = useState("");
  const [fileData, setFileData] = useState("");
  const [file, setFile] = useState([]);
  const dispatch = useDispatch();
  const [confirmClose, setConfirmClose] = useState(false);

  const fetchReversalTypes = async (type, Id1, Id2) => {
    setchargeId(Id1);
    setPaymentId(Id2);
    const token = await getAccessTokenSilently();
    await FinanceService.getAllReversalTypes(type, token)
      .then((res) => {
        setActionTypes(res?.result);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });

    setReversalActionTypes(true);
  };
  const handleCloseDialog = () => {
    setReversalActionTypes(false);
  };
  const onModalClose = () => {
    closeModal();
  };
  const closeModal = () => {
    setInvoiceFile(false);
    setReceiptFile(false);
    setShareInvoicePDF("");
    setShareReceiptPDF("");
    setInvoiceDownload(false);
    setReceiptDownload(false);
  };
  const invoiceClick = () => {
    setInvoiceFile(true);
    fetchMyAPI(data?._id, "invoice");
  };
  const receiptClick = () => {
    setReceiptFile(true);
    fetchMyAPI(data?.charge?._id, "receipt");
  };
  const handelInvoiceShare = () => {
    fetchMyAPI(data?._id, "invoice");
    setShareInvoicePDF("invoice");
  };
  const handelReceiptShare = () => {
    fetchMyAPI(data?.charge?._id, "receipt");
    setShareReceiptPDF("receipt");
  };

  const invoiceDownloadClick = async () => {
    setInvoiceFile(false);
    await fetchMyAPI(data?._id, "invoice");
    setInvoiceDownload(true);
  };
  const receiptDownloadClick = async () => {
    await fetchMyAPI(data?.charge?._id, "receipt");
    setReceiptDownload(true);
    setTimeout(() => {
      setReceiptFile(false);
    }, 1000);
  };
  const fetchMyAPI = async (id, type) => {
    const token = await getAccessTokenSilently();
    await FinanceService.getDocumentByTransactionId(token, id, type)
      .then((res) => {
        const result = res?.result?.[0];
        setInvoiceReceiptData(result);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };
  const getCommaSeperatedValue = (num) => {
    return CheckFloatValue(
      parseFloat(num?.toString().replace(/,/g, ""))
    ).toLocaleString();
  };


  const [openModalDialog, setOpenModalDialog] = React.useState(false);
  const [showWarningDeleteDialog, setShowWarningDeleteDialog] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openCancleModalDialog, setOpenCancleModalDialog] = React.useState(false);
  const [recurringAction, setRecurringAction] = useState("");

  useEffect(() => {
    if (recurringAction === "") return;
    onSelectedPayment(data, recurringAction)
  }, [recurringAction])

  const onCancelClick = async () => {
    setOpenCancleModalDialog(true);
  }

  const handelSubmit1 = () => {
    setRecurringAction("disable");
  }

  const onDeleteClick = async (row) => {
    const isZeroPaid = parseFloat(row?.charge?.paid) === 0;
    const isReversed = row?.charge?.sub_status === "reversal" || row?.charge?.payment?.status === "reversal";
    setSelectedRow(row);
    if (isZeroPaid && isReversed) {
      setShowWarningDeleteDialog(true);
    } else {
      setOpenModalDialog(true);
    }
  }

  const onSelectedPayment = async (row) => {
    const payload = {
      "transactionId": data?._id ?? "64620154b09a58002fc35dd2",
      "status": recurringAction
    }
    const token = await getAccessTokenSilently();
    await FinanceService.PaymentInfoAction(payload, token).then((res) => {
      // setPaymentAction(true);
      setOpenCancleModalDialog(false);
      toastr.success(res.message ?? "Action Successfully Completed!");
    }).catch((error) => {
      // setPaymentAction(true);
      toastr.error(error?.data?.message);
    });
  }

  const handleSubmit = async () => {
    const token = await getAccessTokenSilently();

    await FinanceService.deleteTransaction(selectedRow, token, selectedRow?.charge?._id ?? "")
      .then((res) => {
        if (res) {
          toastr.success("Transaction deleted successfully");
          setOpenModalDialog(false);
          setShowWarningDeleteDialog(false);
        }
      })
      .catch((err) => {
        toastr.error(err?.data?.message);
        setOpenModalDialog(false);
        setShowWarningDeleteDialog(false);
      });
  };

  const original_amount =
    data?.discount
      ? data?.discount_type === "%"
        ? data?.discount === 100
          ? data?.originalAmount
          : data?.total_amount / (1 - data?.discount / 100)
        : data?.total_amount + data?.discount
      : data?.total_amount;

  const original_amount_for_bulk =
    data?.charge?.discount
      ? data?.charge?.discount_type === "%"
        ? data?.discount === 100
          ? data?.originalAmount
          : data?.charge?.amount / (1 - data?.charge?.discount / 100)
        : data?.charge?.amount + data?.charge?.discount
      : data?.charge?.amount;

  const onChargeEditClick = (row) => {
    document.dispatchEvent(new CustomEvent("edit-charge", { detail: row }));
  };

  const onUpdateClick = async (row) => {
    // const token = await getAccessTokenSilently();

    document.dispatchEvent(new CustomEvent("edit-charge", { detail: row }));
    dispatch(HidePaymentInfoButton(true));

    if (row?.charge?.payment?.status === "partialy_applied" || row?.charge?.payment?.status === "close") {
      localStorage.setItem("TransStatus", "close")
    }

  };
  const [reponse, setResponse] = useState({});
  const [open, setOpen] = useState(false);
  const [isSaved, setSaved] = useState(false);
  const [hfinish, setHFinish] = useState(false);
  const [stepOne, setStepOne] = useState(true);
  const [stepper, setStepper] = useState("New Charge");
  const [accountTransactionModal, setAccountTransactionModal] = useState(false);
  const [batchList, setbatchList] = useState(false);

  const closeModals = () => {
    setStepOne(true);
    setOpen(false);
    setAccountTransactionModal(false);
  };

  const displayInstallmentStatus = (data) => {
    const status = data?.charge?.installmentDetails?.status;
    switch (status) {
      case "active":
        return "Active";
      case "disable":
        return "Disabled";
      case "on-hold":
        return "On-hold";
      case "completed":
        return "Completed";
      default:
        return "Active";
    }
  }

  const displayRecurringStatus = (data) => {
    const status = data?.recurringDetails?.recurringStatus;
    switch (status) {
      case "active":
        return "Active";
      case "declined":
        return "Declined";
      case "on-hold":
        return "On-hold";
      case "disable":
        return "Disabled";
      default:
        return "";
    }
  }

  const onModalCloses = () => {
    if (isSaved || hfinish) {
      closeModals();
      dispatch(SetRecurringChecks("hide"));
      // localStorage.setItem("setRecurring", "false");
    } else {
      closeModals();
      dispatch(SetRecurringChecks("hide"));
      // localStorage.setItem("setRecurring", "false");
    }
  };

  const onPayNowClick = (row) => {
    dispatch(PayNow({ detail: row }));
    setResponse({
      ...data,
      type: "pay-now",
    });

    setOpen(true);
    window.dispatchEvent(new CustomEvent("pay-now", { detail: row }));
  };
  // if bulkPaymentFlag true this means that we are on bulk payment tab 
  if (data?.bulkPaymentFlag && data?.isBulkPayment) {
    return (
      <div className="drawer-header p-8">
        <div className="drawer-title text-center">{!data?.isBulkPayment ? "Payment info" : "Bulk payment info"}</div>
        <p> </p>
        <p className="drawer-row">
          <div className="text-nowrap">{!data?.isBulkPayment ? "Payment#" : "Bulk payment#"}</div>
          <div className="value" title={data?.bulkPaymentId}>
            {data?.bulkPaymentId ? data?.bulkPaymentId : "-"}
          </div>
        </p>
        <p className="drawer-row">
          <div className="">Paid amount</div>
          <div className="value">
            {numberFormat({ number: +data?.paid, decimal: 2, style: 'currency' })}
          </div>
        </p>
        <p className="drawer-row">
          <div className="">Paid at</div>

          <div className="value">
            {formatDate({
              date: (data?.charge?.payment?.History?.created_at ?? data?.created_at
              ), formatType: "defaultWithTimeUTC"
            })}
          </div>
        </p>

        <p className="drawer-row">
          <div className="">Payment Method</div>
          <div className="value">
            {data?.paymnetMethod ? data?.paymnetMethod?.replace(/_/g, ' ')?.toUpperCase() : data?.paymnetMethod?.method?.replace(/_/g, ' ')?.toUpperCase() ?? ''}
          </div>
        </p>
        {data?.charge?.payment?.History?.paymnetMethod?.check_number ? (
          <p className="drawer-row">
            <div className="">Check #</div>
            <div className="value">{data?.charge?.payment?.History?.paymnetMethod?.check_number}</div>
          </p>
        ) : (
          ''
        )}
        {!data?.isBulkPayment && (
          <p className="drawer-row">
            <div className="">Sync info</div>
            <div className="value">
              {data?.is_synced ? data?.synced_Batch : 'Not synced'}
            </div>
          </p>
        )}
        {data?.charge?.payment?.History?.is_third_party && (
          <p className="drawer-row">
            <div className="">Paid By</div>
            <div className="value">
              <a href={`/member-details/${data?.charge?.payment?.History?.third_party_id}`} target="_blank" rel="noreferrer" className="paid-by__third-party">
                {data?.charge?.payment?.History?.third_party_id}
              </a>
            </div>
          </p>
        )}
        <hr className="my-10" />
      </div>
    );
  }

  const closeFinanceModal = () => {
    setConfirmClose(true);
  }

  const confirmCloseFinanceModal = () => {
    setConfirmClose(false);
    onModalCloses();
  }

  return (
    <>
      <MyModal
        className="new-charge-modal"
        open={
          invoiceDownload
            ? invoiceDownload
            : shareIncvoicePDF == "invoice"
              ? true
              : invoiceFile
        }
        onClose={onModalClose}
      >
        <InvoiceDocument
          setFileData={setFileData}
          data={invoiceReceiptData}
          finance="finance"
          downloadPDF={invoiceDownload}
          sharePDF={shareIncvoicePDF}
        />
      </MyModal>
      <MyModal
        className="new-charge-modal"
        open={
          receiptDownload
            ? receiptDownload
            : shareReceiptPDF === "receipt"
              ? true
              : receiptFile
        }
        onClose={onModalClose}
      >
        <ReceiptDocument
          setFileData={setFileData}
          data={invoiceReceiptData}
          setFile={setFile}
          finance="finance"
          downloadPDF={receiptDownload}
          sharePDF={shareReceiptPDF}
        />
      </MyModal>
      <div className="">
        <div className="drawer-header">
          <div className="cursor-pointer">
            {batchTable === "batchtable" || data?.bulkPaymentFlag || data?.bulkPaymentCharge || hideActions ? <></> : <Action
              style={{ width: "16px" }}
              action="finance"
              actionDrawer="drawer"
              chargeStatus={
                data?.charge?.amount -
                  data?.charge?.paid +
                  data?.charge?.discount >
                  0 &&
                  data?.charge?.amount -
                  data?.charge?.paid +
                  data?.charge?.discount <
                  data?.charge?.amount
                  ? "partially_paid"
                  : data?.charge?.payment?.status
              }
              hideInvoiceButtons={hideInvoiceButtons}
              hideReceiptButtons={hideReceiptButtons}
              drawerBol={true}
              setInvoiceFile={() => {
                viewFileClickHandler("invoice")
              }}
              setReceiptFile={() => {
                viewFileClickHandler("receipt")
              }}
              setShareInvoicePDF={() => {
                sharedFileClickHandler("invoice")
              }}
              setShareReceiptPDF={() => {
                sharedFileClickHandler("receipt")
              }}
              setInvoiceDownload={() => {
                downloadFileClickHandler("invoice")
              }}
              setReceiptDownload={() => {
                downloadFileClickHandler("receipt")
              }}
              onUpdateClick={onUpdateClick}
              onReversalClick={() =>
                fetchReversalTypes(
                  data?.charge?.status === "charge"
                    ? "charge"
                    : data?.charge?.status === "payment"
                      ? "payment"
                      : "",
                  data?.charge?._id,
                  data._id
                )
              }
              onPayClick={hidePayNow ? undefined : () => { onPayNowClick(data); }}
              onChargeEditClick={() => onChargeEditClick(data)}
              onUpdatePaymentClick={() => {
                onChargeEditClick(data);
              }}
              onDeleteClick={hideDelete ? undefined : () => { onDeleteClick(data) }}
              onCancelClick={() => {
                onCancelClick()
              }}
              OnRecurringAction={setRecurringAction}
              disableActionButton={disableActionButton}
              row={data}
            />}
            <MainDialog
              open={reversalActionTypes}
              getTypes={getTypes}
              handleClose={handleCloseDialog}
              onDecline={() => {
                setReversalActionTypes(false);
              }}
              onAccept={(id, type, hidden) =>
                onReversalClick(
                  data?.charge?.status === "charge"
                    ? { chargeId: data?.charge?._id }
                    : data?.charge?.status === "payment"
                      ? {
                        reversal_type: {
                          id: id,
                          type: type,
                          hidden: hidden,
                        },
                        chargeId: chargeId,
                        paymentId: paymentId,
                      }
                      : "",
                  setReversalActionTypes
                )
              }
              content={"Choose a reversal type "}
            />
          </div>
        </div>
        {data?.charge?.payment?.status === "declined" && <>
          <div className="drawer-title">PAYMENT DECLINED</div>
          <div className="drawer-content ">
            <div className="first-pr">
              <p className="drawer-row">
                <div className="">Decline Type</div>
                <div className="value" title={'Decline Type'}>
                  {"Card Expired"}
                </div>
              </p>
            </div>
            <hr className="my-5" />
          </div>
        </>
        }
        <div className="drawer-content ">
          {(data?.created_at && data.is_reversed === false) || data?.bulkPaymentFlag ? (
            <>
              <div className="drawer-title">Payment info</div>
              <p> </p>
            </>
          ) : data?.created_at && data.is_reversed === true ? (
            <>
              <div className="drawer-title">Reversed Payment</div>
              <p> </p>
            </>
          ) : (
            ""
          )}
          <div className="drawer-content ">
            <div className="second-pr">
              {(data?.created_at && data.is_reversed === false) || data?.bulkPaymentFlag ? (
                <>
                  <p></p>
                  {data?.bulkPaymentFlag && <p className="drawer-row">
                    <div className="">Payment#</div>
                    <div className="value">
                      {data?.charge?.payment?.History?._id}
                    </div>
                  </p>}
                  <p className="drawer-row">
                    <div className="">Paid amount</div>
                    <div className="value">
                      {
                        data?.bulkPaymentFlag ?
                          numberFormat({ number: +data?.paid, decimal: 2, style: 'currency' }) :
                          numberFormat({ number: (data?.amount ?? +data?.charge?.paid ?? 0), decimal: 2, style: 'currency' })
                      }
                    </div>
                  </p>
                  <p className="drawer-row">
                    <div className="">Paid at</div>

                    <div className="value">
                      {formatDate({ date: (data?.bulkPaymentFlag ? data?.charge?.payment?.History?.created_at : data?.created_at), formatType: "defaultWithTimeUTC" }) ?? "-"}
                    </div>
                  </p>

                  <p className="drawer-row">
                    <div className="">Payment Method</div>
                    <div className="value">
                      {
                        data?.bulkPaymentFlag ? data?.paymnetMethod?.replace(/_/g, " ")?.toUpperCase()
                          : data?.paymnetMethod?.method
                            ?.replace(/_/g, " ")
                            ?.toUpperCase() ?? ""
                      }
                    </div>
                  </p>
                  {data?.paymnetMethod?.check_number ? (
                    <p className="drawer-row">
                      <div className="">Payment info</div>
                      <div className="value">
                        {data?.paymnetMethod?.check_number}
                      </div>
                    </p>
                  ) : (
                    ""
                  )}
                  <p className="drawer-row">
                    <div className="">Convenience fee</div>
                    <div className="value">
                      {numberFormat({ number: data?.charge?.payment?.convenient_fee, decimal: 2, style: 'currency' })}
                    </div>
                  </p>
                  <p className="drawer-row">
                    <div className="">Sync info</div>
                    <div className="value">
                      {switchType === "payment" ? data?.charge?.payment?.History?.is_synced ? data?.charge?.payment?.History?.synced_Batch : "Not synced" : data?.is_synced ? data?.synced_Batch : "Not synced"}
                    </div>
                  </p>
              <p className="drawer-row">
                <div className="">Bulk Payment</div>
                <div className="value">{ data?.isBulkPayment ?"Yes" :"No"}</div>
              </p>
                  <p className="drawer-row mt-5">
                    <div className="">{data?.comment_invoice?.note}</div>
                  </p>

                  {(data?.is_third_party || data?.charge?.payment?.History?.is_third_party) && (
                    <p className="drawer-row">
                      <div className="">Paid By</div>
                      <div className="value">
                        <a href={`/member-details/${data?.charge?.payment?.History?.third_party_id || data?.third_party_id}`} target="_blank" rel="noreferrer" className="paid-by__third-party">
                          {data?.charge?.payment?.History?.third_party_id || data?.third_party_id}
                        </a>
                      </div>
                    </p>
                  )}
                  <hr className="my-10" />
                </>
              ) : data?.created_at && data.is_reversed === true ? (
                <>
                  <p className="drawer-row">
                    <div className="">Resveral type</div>
                    <div className="value">{data?.reversal_type?.type}</div>
                  </p>

                  <hr className="my-10" />
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          {data?.charge?.isInstallment && (
            <>
              <div className="drawer-title">
                Installments
              </div>
              <div className="drawer-content ">
                <div className="first-pr">
                  <p className="drawer-row">
                    <div className="">amount</div>
                    <div className="value">
                      {numberFormat({ number: data?.charge?.installmentDetails?.amount, decimal: 2, style: 'currency' })}
                    </div>
                  </p>
                  <p className="drawer-row">
                    <div className="">installments</div>
                    <div className="value">
                      {data?.charge?.installmentDetails?.cycle}
                    </div>
                  </p>
                  <p className="drawer-row">
                    <div className="">Paid</div>
                    <div className="value">
                      {numberFormat({ number: data?.charge?.installmentDetails?.paid, decimal: 2, style: 'currency' })}
                    </div>
                  </p>
                  <p className="drawer-row">
                    <div className="">Payment starts</div>
                    <div className="value">
                      {formatDate({ date: data?.charge?.installmentDetails?.installmentStart, formatType: "defaultWithUTC" })}
                    </div>
                  </p>
                  <p className="drawer-row">
                    <div className="">Status</div>
                    <div className="value">
                      {displayInstallmentStatus(data)}
                    </div>
                  </p>
                </div>
              </div>
              <hr className="my-5" />
            </>
          )}
          {data?.isRecurring && (
            <>
              <div className="drawer-title">
                Recurring
              </div>
              <div className="drawer-content ">
                <div className="first-pr">
                  <p className="drawer-row">
                    <div className="">Status</div>
                    <div className="value">
                      {displayRecurringStatus(data)}
                    </div>
                  </p>
                </div>
              </div>
              <div className="second-pr">
                <>

                </>
              </div>
              <hr className="my-5" />
            </>
          )}


          <div className="drawer-title">
            {data?.charge_type === "charge"
              ? "Charge"
              : data?.charge_type === "credit_on_account"
                ? "Credit On Account"
                : "Charge"}{" "}
            info
          </div>
          <div className="drawer-content ">
            <div className="first-pr">
              <p className="drawer-row">
                <div className="">Charge#</div>
                <div className="value" title={data?.charge?._id}>
                  {" "}
                  {data?.charge?._id ? data?.charge?._id : "-"}
                  {/* {data._id ? data._id.slice(0, 5) + "..." : "-"} */}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Amount</div>
                <div className="value">
                  {
                    data?.bulkPaymentFlag && data?.isBulkPayment ? `${numberFormat({ number: +data?.charged, decimal: 2, style: 'currency' })}` : numberFormat({ number: (+data?.charge?.amount + data?.charge?.discount), decimal: 2, style: 'currency' })
                  }
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Paid</div>
                <div className="value">
                  {data?.bulkPaymentFlag ? numberFormat({ number: +data?.paid, decimal: 2, style: 'currency' }) :
                    numberFormat({ number: +data?.charge?.paid, decimal: 2, style: 'currency' })}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Due</div>
                <div className="value">
                  {numberFormat({
                    number:
                      (
                        +data?.charge?.amount +
                        data?.charge?.discount -
                        data?.charge?.paid
                      ), decimal: 2, style: 'currency'
                  }
                  )}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Discount</div>
                <div className="value">
                  {numberFormat({ number: data?.charge?.discount, decimal: 2, style: 'currency' })}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Due Date</div>
                <div className="value">
                  {formatDate({ date: data?.charge?.due_date, formatType: "defaultWithUTC" }) || "-"}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Convenience fee</div>
                <div className="value">
                  {numberFormat({ number: +data?.charge?.payment?.convenient_fee, decimal: 2, style: 'currency' })}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Status</div>
                <div className="value">{data?.charge?.status}</div>
              </p>
              <p className="drawer-row">
                <div className="">Sync info</div>
                <div className="value">
                  {data?.charge?.is_synced
                    ? data?.charge?.synced_Batch
                    : "Not synced"}
                </div>
              </p>
            </div>
          </div>

          <hr className="my-5" />
          <div className="drawer-title">Transaction info</div>
          <div className="first-pr">
            <p className="drawer-row">
              <div className="">Transaction#</div>
              <div className="value" title={data?.transactionId || data?._id}>
                {data?.transactionId || data?._id || "-"}
              </div>
            </p>
            <p className="drawer-row">
              <div className="">Split</div>
              <div className="value">
                {data?.is_splitted ? data?.number_of_split : "No"}
              </div>
            </p>
            <p className="drawer-row">
              <div className="">Original Amount</div>
              <div className="value">
                {numberFormat({ number: (data?.bulkPaymentFlag ? +original_amount_for_bulk : +original_amount), decimal: 2, style: 'currency' })}
              </div>
            </p>
            <p className="drawer-row">
              <div className="">Discount</div>
              <div className="value">
                {numberFormat({ number: data?.discount ?? 0, decimal: 2, style: data?.discount_type === "%" ? 'decimal' : 'currency' })}
                {data?.discount_type === "%" ? "%" : ""}
              </div>
            </p>
            <p className="drawer-row">
              <div className="">Total Amount</div>
              <div className="value">
                {numberFormat({ number: (data?.bulkPaymentFlag ? data?.charge?.amount : +data?.total_amount), decimal: 2, style: 'currency' })}
              </div>
            </p>
            <p className="drawer-row">
              <div className="">Convenience fee</div>
              <div className="value">
                {numberFormat({ number: (+data?.charge?.payment?.convenient_fee || 0), decimal: 2, style: 'currency' })}
              </div>
            </p>

            <p className="drawer-row">
              <div className="">Remaining balance</div>
              <div className="value">
                {numberFormat({
                  number: (
                    +data?.charge?.amount +
                    data?.charge?.discount -
                    data?.charge?.paid
                  ), decimal: 2, style: 'currency'
                }

                )}
              </div>
            </p>

            <p className="drawer-row">
              <div className="">Status</div>
              <div className="value">{data?.charge?.status}</div>
            </p>
            <p className="drawer-row">
              <div className="">Created Date</div>
              <div className="value">
                {data?.createdAt ? formatDate({ date: data?.createdAt, formatType: "defaultWithUTC" }) : "-"}
              </div>
            </p>
            <p className="drawer-row">
              <div className="">Source</div>
              <div className="value">{data?.source || "-"}</div>
            </p>
            <p className="drawer-row">
              <div className="drawer-row">Ledger Account</div>
              <div className="value">
                {data?.Ledger?.name} / {(data?.SubLedger?.name && data?.SubLedger?.name !== "N/A") ? data?.SubLedger?.name : "-"}{" "}
              </div>
            </p>
          </div>

          <hr className="my-5" />

          <div className="second-pr">
            <>
              <p className="drawer-row mt-5">
                <div className="">{data?.comment_invoice?.note}</div>
              </p>
            </>
          </div>
        </div>

        {(data) && (
          <MyModal
            className={stepOne ? "new-charge-modal" : "new-charge-modal-w"}
            open={open}
            onClose={closeFinanceModal}
          >
            <UserContext.Provider value={{ hfinish, setHFinish }}>
              <NewCharge
                setStepOne={setStepOne}
                setStepper={setStepper}
                handleClose={onModalCloses}
                data={data}
                // data={accountTransactionModal ? "" : PayNowData?.detail}
                activeIndex={accountTransactionModal ? 0 : 1}
                setSaved={setSaved}
                setBatchList={setbatchList}
              />
            </UserContext.Provider>
          </MyModal>
        )}

        <AlertDialog
          open={openModalDialog}
          handleClose={() => setOpenModalDialog(false)}
          onDecline={() => {
            setOpenModalDialog(false);
          }}
          onAccept={() => {
            handleSubmit();
          }}
          title={"Are you sure?"}
          description={"Deleting this transaction is non-reversible. would you like to proceed?"}
        />
        <AlertDialog
          open={showWarningDeleteDialog}
          onDecline={() => setShowWarningDeleteDialog(false)}
          onAccept={() => handleSubmit()}
          acceptBtnText="Delete"
          title="Delete Charge"
          description={
            <div style={{ textAlign: "left", color: "#002E5C" }}>
              <p style={{ marginBottom: "10px", fontWeight: "700" }}>This charge is already paid, reversed, or synced.</p>
              <p style={{ marginBottom: "10px" }}>Deleting it here will not update your accounting records in your accounting system.</p>
              <p style={{ marginBottom: "20px" }}>You are responsible for making any necessary changes directly in your accounting system.</p>
              <p style={{ fontWeight: "700" }}>Are you sure you want to delete this charge?</p>
            </div>
          }
        />
        <AlertDialog
          open={openCancleModalDialog}
          handleClose={handleCloseDialog}
          onDecline={() => {
            setOpenCancleModalDialog(false);
          }}
          onAccept={() => {
            handelSubmit1()
            // onSelectedPayment(row);
          }}
          title={"Are you sure?"}
        />
        <AlertDialog
          open={confirmClose}
          handleClose={() => setConfirmClose(false)}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={confirmCloseFinanceModal}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
      </div>
    </>
  );
};